import React from 'react';
import DestinationSectionLoader from './destinationSectionLoader';
import AriaModal from 'react-aria-modal';

const TopDestinationDetailSection = (prop) => {

    const defaultImage = 'https://travel-img-assets.s3.us-west-2.amazonaws.com/no-image/no-image-500x300.png';
    const topDestinations = prop.topDestinations;
    const firstDestName = prop.firstDestName;
    const firstDestDesc = prop.firstDestDesc;
    const topItems = prop.topItems;
    const showDescModal = prop.showDescModal;

    return (
        <>
            {
                (topDestinations) ? (
                    <>
                        <div className="tab-pane fade show active" id="Sun" role="tabpanel" aria-labelledby="sub-tab">
                            <div className="row gutter-10">
                                {firstDestName !== undefined && firstDestName !== null && firstDestName !== '' && (
                                    <div className="col-lg-3 col-md-4 mb-3 mb-xl-0">
                                        <div className="box-shadow-md py-5 px-4 rounded-sm h-100">
                                            <div className="d-flex flex-column justify-content-center h-100">
                                                <h4 className="mb-4 font-weight-bold">
                                                    {firstDestName}
                                                </h4>
                                                <p className="font-weight-500 mb-1">
                                                    { firstDestDesc.length > 180 ?
                                                        <>
                                                            <div dangerouslySetInnerHTML={{ __html: firstDestDesc.substring(0, 180)+'... ' }} />
                                                            <a href="javascript:;" className="text-secondary font-weight-600 h5 mt-4" onClick={() => { prop.showDetailModal(true); }}>
                                                                More
                                                            </a>
                                                        </>
                                                    :
                                                        <div dangerouslySetInnerHTML={{ __html: firstDestDesc }} />
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="col-lg-9 col-md-8">
                                    <div className="row gutter-10">
                                        { topItems !== undefined && topItems !== null && topItems.length > 0 ?
                                            <>
                                                {topItems.map((item, key) => {
                                                    const currentImgNo = key + 1;
                                                    if(item.name != undefined ) {
                                                        return (
                                                            <div className="col-6 col-sm-6 col-xl col-lg-4 col-md-4 mb-3 mb-xl-0">
                                                                <div className="rounded-sm box-shadow-md p-2 pt-4">
                                                                    <button className="btn-unstyled deal-list-card text-decoration-none position-relative" style={{cursor: "default"}}>
                                                                        <span className="counter-circle-list rounded-circle center font-weight-bold">
                                                                            {currentImgNo}
                                                                        </span>
                                                                        <div className="position-relative w-100 rounded-4 overflow-hidden" onClick={() => { prop.updateCountryDetail(item); }}>
                                                                            <img className="w-100 object-fit-cover rounded-sm" height="250" src={(item.image != undefined && item.image != '') ? item.image : defaultImage} data-was-processed="true"/>
                                                                            <div className="position-absolute bottom-0 w-100 py-2 bg-black-transparent">
                                                                                <h6 className="text-white text-center mb-0 font-size-md">{item.name}</h6>
                                                                            </div>
                                                                        </div>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        );
                                                    }  
                                                })}
                                            </>
                                        : null }
                                    </div>
                                </div>
                            </div>
                        </div>
                        {showDescModal && (
                            <AriaModal
                                initialFocus="#mdl-content"
                                aria-describedby="mdl-content"
                                titleId="mdl-title"
                                aria-labelledby="mdl-title"
                                dialogStyle={{ width: '1000px' }}
                                aria-modal="true"
                                verticallyCenter
                            >
                                <div className="modal-dialog modal-xl">
                                    <div className="modal-content modal">
                                        <h5 className="modal-title mb-0 px-4 pt-3 primary-color font-weight-bold" id="mdl-title">
                                            {firstDestName}
                                        </h5>
                                        <button
                                            type="button"
                                            onClick={() => { prop.showDetailModal(false);}}
                                            className="close close-lg position-absolute top-right p-0 m-0"
                                            aria-label="Close"
                                        >
                                            <span className="pt-md-1 d-inline-block" aria-hidden="true">
                                                ×
                                            </span>
                                        </button>
                                        <div className="modal-main p-0" id="mdl-content">
                                            <div className="content">
                                                <div className="mb-0 p-4 pt-3" dangerouslySetInnerHTML={{ __html: firstDestDesc }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </AriaModal>
                        )}
                        
                    </>
                ) : <DestinationSectionLoader />
            }
        </>
    );
};

export default TopDestinationDetailSection;
